<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="医生姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['doctorName']" placeholder="请输入医生姓名"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="头像" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-image-upload isMultiple v-decorator="['headImg']"></j-image-upload>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="医院" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['hospital']" placeholder="请输入医院"></a-input>
            </a-form-item>
          </a-col>
          <!-- <a-col :span="24">
            <a-form-item label="头衔" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['master']" placeholder="请输入头衔"></a-input>
            </a-form-item>
          </a-col> -->
          <a-col :span="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="头衔" hasFeedback validateStatus="warning" >
              <a-select v-decorator="['master']" >
                <a-select-option value="1">国医大师</a-select-option>
                <a-select-option value="2">全国名中医</a-select-option>
                <a-select-option value="3">国家级名老中医</a-select-option>
                <a-select-option value="4">市级名老中医</a-select-option>
                <a-select-option value="5">首都国医名师</a-select-option>
                <a-select-option value="0">暂不选择</a-select-option>
                </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="状态 0正常 1删除" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['status']" placeholder="请输入状态码"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="序号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['sort']" placeholder="请输入序号"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="擅长" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea v-decorator="['goodDesc']" rows="4" placeholder="请输入擅长"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="简介" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea v-decorator="['introductionTitle']" rows="4" placeholder="请输入简介"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="关键字（第几届）" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['keyWord']" placeholder="请输入关键字（第几届）"></a-input>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JImageUpload from '@/components/jeecg/JImageUpload'

  export default {
    name: 'TcmTankForm',
    components: {
      JFormContainer,
      JImageUpload,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
validatorRules: {
},
        url: {
          add: "/tcmTank/tcmTank/add",
          edit: "/tcmTank/tcmTank/edit",
          queryById: "/tcmTank/tcmTank/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'doctorName','doctorId','headImg','hospital','master','status','sort','goodDesc','introductionTitle','keyWord'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'doctorName','doctorId','headImg','hospital','master','status','sort','goodDesc','introductionTitle','keyWord'))
      },
    }
  }
</script>